import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Language, Login, Profile } from "../../../../components/Icons";
import { LayoutList, UserRoundPen, Star, LogOut } from "lucide-react";
import { useTranslation } from "../../../../hooks/useTranslation";
import { changeSiteLang, logUserOut } from "../../../../store/userSlice";
import style from "./index.module.css";
import { vehicleModules, vehicleTypes } from "../../../../utils/GeneralTypes";

const SubHeader = ({ user }: ComponentPropsType) => {
  const { locale, siteLang } = useTranslation();
  const dispatch = useDispatch();

  const onToggleControlsHandler = useCallback((e) => {
    const single_control = e.target.closest(`.${style.single_control}`);
    if (single_control) {
      const single_control_nav = single_control.children[1];
      const all_single_control_navs = Array.from(document.querySelectorAll(".single_control_nav"));
      if (single_control_nav) {
        if (single_control_nav.classList.contains(style.active)) single_control_nav.classList.remove(style.active);
        else {
          all_single_control_navs.forEach((el) => {
            el.classList.remove(style.active);
          });
          single_control_nav.classList.add(style.active);
        }
      }
    }
  }, []);

  useEffect(() => {
    const collapseAllControls = (e: any) => {
      const all_single_control_navs = Array.from(document.querySelectorAll(".single_control_nav"));
      all_single_control_navs.forEach((el) => {
        if (el.classList.contains(style.active) && !e.target.closest(".single_control_btn"))
          el.classList.remove(style.active);
      });
    };

    document.documentElement.addEventListener("click", collapseAllControls);

    return () => document.documentElement.removeEventListener("click", collapseAllControls);
  }, []);

  return (
    <div className={style.sub_header}>
      <div className="container-lg">
        <div className={style.sub_header__content}>
          {/*
          <div className={style.single_control}>
            <span onClick={onToggleControlsHandler} className="single_control_btn">
              {locale("distributor")}
            </span>
            <ul className="single_control_nav">
              {vehicleModules.map((vehicelName) => (
                <li key={`ddistributor${vehicelName.single}`}>
                  <Link to={`/distributor/${vehicelName.plural}`}>{locale(vehicelName.plural)}</Link>
                </li>
              ))}
            </ul>
          </div>
          */}
          <nav>
            {/* <li>
              <Link to="/vehicles/search">{locale("vehiclesSearch")}</Link>
            </li> */}
            <li>
              <Link to="/showrooms">{locale("showrooms")}</Link>
            </li>
            <li>
              <Link to="/service-centers">{locale("service_centers")}</Link>
            </li>
            {/* <li>
              <Link to="/compare/cars/new">{locale("compare")}</Link>
            </li> */}
            <li>
              <Link to="/news">{locale("news")}</Link>
            </li>
            <li>
              <Link to="/contact">{locale("contact_us")}</Link>
            </li>
          </nav>
          <div className={style.controls}>
            <div className={style.single_control}>
              <span onClick={onToggleControlsHandler} className="single_control_btn">
                <Language width="17" height="17" color="#dc0000" />
                {locale("language")}
              </span>
              <ul className="single_control_nav">
                <li>
                  <button
                    onClick={() => (siteLang === "en" ? {} : changeSiteLang("en"))}
                    {...(siteLang === "en" ? { className: style.active } : {})}
                  >
                    English
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => (siteLang === "ar" ? {} : changeSiteLang("ar"))}
                    {...(siteLang === "ar" ? { className: style.active } : {})}
                  >
                    عربى
                  </button>
                </li>
              </ul>
            </div>

            {user ? (
              <div className={style.single_control}>
                <span onClick={onToggleControlsHandler} className="single_control_btn">
                  <Profile width="17" height="17" color="#dc0000" />
                  {locale("profile")}
                </span>
                <ul className="single_control_nav">
                  <li>
                    <UserRoundPen width="17" height="17" color="#dc0000" />&nbsp;
                    <Link to="/profile">{locale("edit_profile")}</Link>
                  </li>
                  <li>
                    <Star width="17" height="17" color="#dc0000" />&nbsp;
                    <Link to={`/wishlist/${vehicleModules[0].plural}/used`}>{locale("wishlist")}</Link>
                  </li>
                  <li>
                  <LayoutList width="17" height="17" color="#dc0000" />&nbsp;
                    <Link to={`/my-vehicles/${vehicleModules[0].plural}`}>{locale("my_vehicles")}</Link>
                  </li>
                  <li>
                    <button onClick={() => dispatch(logUserOut())}>
                      <LogOut width="17" height="17" color="#dc0000" />&nbsp;
                      {locale("logout")}
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <div className={style.single_control_link}>
                <Link to="/sign">
                  <Login width="17" height="17" color="#dc0000" />
                  {locale("login")}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;

type ComponentPropsType = {
  user: any;
};
